export const CONTACT_EVENT_TYPES = [
  'signup',
  'profile_completed',
  'upgrade',
  'downgrade',
  'cancel_requested',
  'canceled',
  'payment_failed',
  'trial_ending',
  'approved',
  'deactivated',
  'reactivated',
  'email_verified',
  'inactive_for',
  'segment_entered',
  'segment_exited',
  'tag_added',
  'tag_removed',
  'email_sent',
  'email_opened',
  'email_clicked',
  'email_unsubscribed',
  'email_resubscribed',
  'note',
] as const;

export type ContactEventType = (typeof CONTACT_EVENT_TYPES)[number];
